import { Component, Input, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { OnboardingCandidateClaimsCompleteService } from "src/app/pages/onboarding/onboarding-candidate-claims-complete.service";
import { AppNotification } from "../../app-notification.model";
import { buildOnboardingPotentialCasesMessage } from "../../onboarding-notification.helper";

@Component({
  selector: "app-notification-item-onboarding-cases",
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: "./notification-item-onboarding-cases.component.html",
  styleUrls: ["./notification-item-onboarding-cases.component.scss"],
})
export class NotificationItemOnboardingCasesComponent {
  private readonly onboardingCompleteSvc = inject(
    OnboardingCandidateClaimsCompleteService,
  );

  @Input({ required: true }) notification!: AppNotification;
  @Input({ required: true }) onActivate!: (notificationId: string) => void;
  @Input({ required: true }) onDismiss!: (notificationId: string) => void;

  get displayMessage(): string {
    return buildOnboardingPotentialCasesMessage(this.notification.payload);
  }

  get storeId(): string {
    return String(this.notification.payload["storeId"] ?? "");
  }

  onItemClick(): void {
    if (!this.storeId) {
      return;
    }

    this.onboardingCompleteSvc.promptNavigateToResults(this.storeId);
    this.onActivate(this.notification.id);
  }

  onDelete(event: Event): void {
    event.stopPropagation();
    this.onDismiss(this.notification.id);
  }
}
